export default "__VITE_ASSET__FT6xzYx3__"